export const appointmentStatus = Object.freeze({
  booked: 'booked',
  happened: 'happened',
  invoiced: 'invoiced',
  paid: 'paid',
  canceled: 'canceled',
  canceledLate: 'canceled_late',
  paidCanceledLate: 'paid_canceled_late',
  invoicedCanceledLate: 'invoiced_canceled_late',
  technicalError: 'technical_error',
  invoicedTechnicalError: 'invoiced_technical_error',
  paidTechnicalError: 'paid_technical_error',
  studentNoShow: 'student_noshow',
  invoicedNoShow: 'invoiced_no_show',
  paidNoShow: 'paid_no_show',
  tutorNoShow: 'tutor_noshow',
  allNoShow: 'all_noshow'
});

export const pastAppointmentStatus = Object.freeze({
  happened: { value: 'happened', label: 'Happened' },
  invoiced: { value: 'invoiced', label: 'Happened' },
  paid: { value: 'paid', label: 'Happened' },
  studentAttended: { value: 'student_show', label: 'Learner attended' },
  studentNoShow: { value: 'student_noshow', label: 'Learner no-show' },
  technicalIssues: { value: 'technical_error', label: 'Technical issues' },
  canceledLate: { value: 'canceled_late', label: 'Canceled Late' },
  paidCanceledLate: { value: 'paid_canceled_late', label: 'Canceled Late' },
  invoicedCanceledLate: { value: 'invoiced_canceled_late', label: 'Canceled Late' },
  invoicedNoShow: { value: 'invoiced_no_show', label: 'Learner no-show' },
  paidNoShow: { value: 'paid_no_show', label: 'Learner no-show' },
  invoicedTechnicalError: { value: 'invoiced_technical_error', label: 'Technical issues' },
  paidTechnicalError: { value: 'paid_technical_error', label: 'Technical issues' }
});

export const tutorAttendanceStatus = Object.freeze({
  tutor_on_time: 'On time',
  tutor_late: 'Late',
  tutor_very_late: 'Very late',
  tutor_no_attendance: 'No attendance'
});

export const getPastAppointmentStatusLabelFromValue = (value) => {
  const findings = Object.values(pastAppointmentStatus).find((obj) => obj.value === value);
  return findings?.label || '';
};

export const isStatusValid = (value) => {
  const findings = Object.values(pastAppointmentStatus).find((obj) => obj.value === value);
  return Boolean(findings?.label);
};

export const parseHappenedToAttended = (status) => {
  return status === pastAppointmentStatus.happened.value ? pastAppointmentStatus.studentAttended.value : status;
};
